import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tab-collection" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 1,
  class: "list"
}
const _hoisted_4 = { class: "platform" }
const _hoisted_5 = {
  key: 0,
  class: "custom-checkbox"
}
const _hoisted_6 = ["onUpdate:modelValue", "name", "id", "onChange"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["for"]
const _hoisted_9 = {
  key: 1,
  class: "platform-label"
}
const _hoisted_10 = {
  key: 0,
  class: "groups"
}
const _hoisted_11 = { class: "custom-checkbox" }
const _hoisted_12 = ["onUpdate:modelValue", "name", "id", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = ["for"]

import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { platformList } from "@/common/api/rest/platform";
import { groupList } from "@/common/api/rest/group";
import {
  collectionPlatformList,
  collectionPlatformCreate,
  collectionPlatformDel,
} from "@/common/api/rest/collection-platform";

import type { GroupType } from "@/common/types/group";
import type { CollectionType } from "@/common/types/collection";

import { baseLoading } from "@/common/components";

interface ListType {
  [key: string]: {
    item_id: string | null;
    platform_id: string;
    name: string;
    selected: boolean;
    groups: {
      [key: string]: {
        item_id: string | null;
        platform_id: string;
        group_id: string;
        name: string;
        selected: boolean;
      };
    } | null;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'platform',
  props: {
    collection: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const search = ref<string>("");
const list = ref<ListType>({});
const loading = ref(false);

async function fetchGroup(platform_id: string) {
  await groupList(platform_id, {
    full: true,
  }).then((response) => {
    const { success, data, message } = response;

    if (success) {
      data.list?.forEach(async (item: GroupType) => {
        list.value = {
          ...list.value,
          [platform_id]: {
            ...list.value[platform_id],
            groups: {
              ...list.value[platform_id].groups,
              [item.group_id]: {
                platform_id: platform_id,
                group_id: item.group_id,
                name: item.name,
                item_id: null,
                selected: false,
              },
            },
          },
        };
      });
    } else {
      toast({ message: message, type: "error" });
    }
  });
}

async function fetchData() {
  await platformList({
    full: true,
    search: search.value,
  })
    .then(async (response) => {
      const { success, data, message } = response;

      if (success) {
        for (const item of data.list || []) {
          list.value = {
            ...list.value,
            [item.platform_id]: {
              platform_id: item.platform_id,
              name: item.name,
              selected: false,
              item_id: null,
              groups: null,
            },
          };
          await fetchGroup(item.platform_id);
        }
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchCollectionPlatforms() {
  await collectionPlatformList(props.collection.collection_id, {
    full: true,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        data.list?.forEach((item: any) => {
          list.value[item.platform_id].item_id = item.item_id;
          list.value[item.platform_id].selected = true;

          if (list.value[item.platform_id].groups?.[item.group_id]) {
            list.value[item.platform_id].groups[item.group_id].item_id =
              item.item_id;
            list.value[item.platform_id].groups[item.group_id].selected = true;
          }
        });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function addCollectionPlatform(
  platform_id: string,
  group_id: string | null = null
) {
  const payload = {
    platform_id: platform_id,
    group_id: group_id,
  };

  await collectionPlatformCreate(props.collection.collection_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCollectionPlatforms();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function removeCollectionPlatform(item_id: string) {
  await collectionPlatformDel(item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchCollectionPlatforms();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function togglePlatform(data: {
  item_id: string;
  platform_id: string;
  selected: boolean;
}) {
  if (data.selected) {
    addCollectionPlatform(data.platform_id);
  } else {
    removeCollectionPlatform(data.item_id);
  }
}

function toggleGroup(data: {
  item_id: string;
  platform_id: string;
  group_id: string;
  selected: boolean;
}) {
  if (data.selected) {
    addCollectionPlatform(data.platform_id, data.group_id);
  } else {
    removeCollectionPlatform(data.item_id);
  }
}

onMounted(async () => {
  loading.value = true;
  await fetchData();
  await fetchCollectionPlatforms();
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(baseLoading), { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (!item.groups)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                          name: item.name,
                          id: item.platform_id,
                          onChange: ($event: any) => (togglePlatform(item))
                        }, null, 40, _hoisted_6), [
                          [_vModelCheckbox, item.selected]
                        ]),
                        _createElementVNode("label", {
                          for: item.platform_id,
                          class: "checkmark"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("label", {
                          for: item.platform_id,
                          class: "platform-label"
                        }, _toDisplayString(item.name), 9, _hoisted_8)
                      ]))
                    : (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(item.name), 1))
                ]),
                (item.groups)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.groups, (group, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "group"
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((group.selected) = $event),
                              name: group.name,
                              id: group.group_id,
                              onChange: ($event: any) => (toggleGroup(group))
                            }, null, 40, _hoisted_12), [
                              [_vModelCheckbox, group.selected]
                            ]),
                            _createElementVNode("label", {
                              for: group.group_id,
                              class: "checkmark"
                            }, null, 8, _hoisted_13),
                            _createElementVNode("label", {
                              for: group.group_id,
                              class: "group-label"
                            }, _toDisplayString(group.name), 9, _hoisted_14)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})